<template>
    <div>
    <b-row role="alert">
        <b-col>
            <div class="sr-only" v-if="isLoading">Pending insterstate endorsement applications loading, please wait...</div>
        </b-col>
    </b-row>
        <b-table hover small responsive show-empty
                 class="sr-caption"
                 aria-live="polite"
                 :id="slug"
                 :fields="fields"
                 :items="items"
                 primary-key="id"
                 :busy="isLoading"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :filter="filter"
                 @filtered="onFiltered"
                 caption="Pending Interstate Endorsement Application table.  To sort the data in this table by a specific column,
                            go to the appropriate column header cell and use enter to sort the data ascending.
                            Use enter again to sort descending.">
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="launchReview(row.item)"
                          variant="primary"
                          class="mr-1">Review</b-button>
            </template>
            <template v-slot:cell(submittedDate)="row">
                {{formatDateTime(row.item.submittedDate)}}
            </template>
            <template v-slot:cell(assignedDate)="row">
              {{formatDate(row.item.assignedDate)}}
            </template>
            <template v-slot:cell(unreadNoteCount)="row">
                <div class="text-center" v-if="row.item.unreadNoteCount>0">
                    <b-button class="btn position-relative btn-primary-outline" size="sm" @click="launchReview(row.item)">
                        <b-icon icon="envelope-open" class="" variant="warning"/>
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white">{{row.item.unreadNoteCount}}</span>

                    </b-button>
                </div>
            </template>
            <template v-slot:no-data>
                <b-button color="primary" @click="initialize">Reset</b-button>
            </template>
            <template v-slot:empty="scope">
                <p>No applications found for this work queue.</p>
            </template>
            <div slot="table-busy" class="center-text text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                           label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>
        </b-table>

        <div class="overflow-auto">
            <b-pagination
                    v-if="this.items.length > perPage"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    :aria-controls="slug"
                    size="sm"/>
        </div>

    </div>
</template>
<style>
    .btn-primary-outline {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    .btn-primary-outline:hover {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
</style>
<script>


    import moment from 'moment';

    export default {
        name: "AdminInterstateTableList",
        props:{
            items: Array,
            slug: [String],
            isLoading: Boolean,
            filter: String,
        },
        data:() => ({
            sortBy: 'submittedDate',
            sortDesc: false, 
            fields:[
                {key: 'fullName', label: 'Full Name', sortable:true},
                {key: 'ssn', label: 'SSN', sortable:true},
                {key: 'certificateNumber', label: 'Certificate Number', sortable: true},
                {key: 'status', label: 'Status', sortable:true},
                {key: 'submittedDate', label:'Submitted Date', sortable:true},
                {key: 'assignedName', label: 'Credentialer Assigned', sortable:true},
              {key: 'assignedDate',label:'Crendialer Assigned Date', sortable: true},
                {key: 'unreadNoteCount', label: 'Unread Messages', sortable:true, class:'text-center'},
                {key: 'actions', label:'Actions', sortable:false}
            ],
            perPage: 10,
            currentPage: 1,
            totalRows: 0,
        }),
        methods:{
            launchReview(item){
                this.$router.push({path: `/review-endorsement/${item.applicationId}`});
            },
            formatDateTime(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY hh:mmA")
            },
            onFiltered(filteredItems) {
                this.setTotalRows(filteredItems.length)
                this.currentPage = 1
            },
            setTotalRows(total){
                this.totalRows = total
            },
          formatDate(unformattedDate){
            let formattedDate = moment(unformattedDate);
            if(!formattedDate.isValid()) return '';
            return formattedDate.format("MM/DD/YYYY")
          },
        },
        watch: {
            items() {
                if (this.totalRows !== this.items.length) {
                    this.setTotalRows(this.items.length)
                }
            }
        }
    }
</script>

<style scoped>

</style>